// Měna podle jazyka: čeština = CZK, ostatní jazyky = EUR (pro zahraniční klienty).
// Ceny počítá backend (převod přes kurz EUR_RATE) — frontend jen vybírá měnu a symbol.

export type Currency = 'czk' | 'eur'

export const currencyForLang = (lang: string): Currency => (lang === 'cs' ? 'czk' : 'eur')

export const currencySymbol = (c: Currency): string => (c === 'eur' ? '€' : 'Kč')

/** Formát čísla s pevnou mezerou v tisících (5 292). */
export const fmtNum = (n: number): string => (n ?? 0).toLocaleString('cs-CZ')
